import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, delay, ease }}
    >
      {children}
    </M>
  );
};

const lineVariants = {
  hidden: { y: "110%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.1, delay: d, ease } }),
};

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, animateOnMount = false }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(animateOnMount ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } })}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span className={`block ${lineClass}`} variants={lineVariants} custom={delay + i * 0.12}>
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const SectionLabel = ({ index, children, light = false }) => (
  <div className={`flex items-center gap-4 eyebrow ${light ? "text-[#E5DEC9]" : "text-[#3D5A4C]"}`}>
    <span className="font-serif-d text-base italic tracking-normal normal-case text-[#B39158]">{index}</span>
    <span className="h-px w-10 bg-current opacity-40" />
    <span>{children}</span>
  </div>
);
